<template>

    <div id="skills_tab" class="flex_content scores_table_container">
        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <div class="show_compare_chart_container" v-if="refEvaluation.saven_test.soft_skills_data.length > 2">
                    <div class="show_compare_chart_button" v-if="false">
                        <button class="button is-outlined is-info table-button" @click="openSkillsCompareModal">
                            {{ $t("modules.positions.evals_detail.showChart") }}
                        </button>
                    </div>
                    <SkillsCompareModal :opened="SkillsCompareModalOpened"
                        @closeSendReport="closeSkillsCompareModal"
                        :BaseSkillData="refEvaluation.saven_test.soft_skills_data"
                        :evaluations="evaluations"
                        skillsKey="soft_skills_data"
                        :selectedEvaluationsIds="selectedPositionEvals" />
                </div>

                <TableWrapper tableContainerId="positions_table_container" v-if="currentRef" class="with_shadow">

                    <template v-slot:tableHead>

                        <tr>
                            <th></th>
                            <th class="eval_username">{{ $t('modules.positions.evals_detail.candidates') }}</th>
                            <th v-if="dimensionsPlan.soft_skills_settings.ui_show_matching"
                                :class="matchingSortingActive()"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('soft_skills_matching')">%</th>

                            <th :class="activeSortingClass('f1')" :data-tooltip="refEvaluation.saven_test.game_rules_data[0].uppole_title " @click="reorderEval('f1')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[0].uppole_title.slice(0,4) }}</span>
                            </th>
                            <th :class="activeSortingClass('f1_r')" :data-tooltip="refEvaluation.saven_test.game_rules_data[0].downpole_title " @click="reorderEval('f1_r')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[0].downpole_title.slice(0,4) }}</span>
                            </th>

                            <th :class="activeSortingClass('f2')" :data-tooltip="refEvaluation.saven_test.game_rules_data[1].uppole_title " @click="reorderEval('f2')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[1].uppole_title.slice(0,4) }}</span>
                            </th>
                            <th :class="activeSortingClass('f2_r')" :data-tooltip="refEvaluation.saven_test.game_rules_data[1].downpole_title " @click="reorderEval('f2_r')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[1].downpole_title.slice(0,4) }}</span>
                            </th>

                            <th :class="activeSortingClass('f3')" :data-tooltip="refEvaluation.saven_test.game_rules_data[2].uppole_title " @click="reorderEval('f3')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[2].uppole_title.slice(0,4) }}</span>
                            </th>
                            <th :class="activeSortingClass('f3_r')" :data-tooltip="refEvaluation.saven_test.game_rules_data[2].downpole_title " @click="reorderEval('f3_r')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[2].downpole_title.slice(0,4) }}</span>
                            </th>

                            <th :class="activeSortingClass('f4')" :data-tooltip="refEvaluation.saven_test.game_rules_data[3].uppole_title " @click="reorderEval('f4')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[3].uppole_title.slice(0,4) }}</span>
                            </th>
                            <th :class="activeSortingClass('f4_r')" :data-tooltip="refEvaluation.saven_test.game_rules_data[3].downpole_title " @click="reorderEval('f4_r')">
                                <span>{{ refEvaluation.saven_test.game_rules_data[3].downpole_title.slice(0,4) }}</span>
                            </th>

                        </tr>
                    </template>

                    <template v-slot:tableBody>
                        <tr class="ref_line" >
                            <td></td>
                            <td class="eval_username">{{ $t('modules.positions.evals_detail.ref_score') }}</td>
                            <td>-</td>

                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[0].ref_score }}</div></td>
                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[0].ref_reverse_score }}</div></td>

                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[1].ref_score }}</div></td>
                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[1].ref_reverse_score }}</div></td>

                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[2].ref_score }}</div></td>
                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[2].ref_reverse_score }}</div></td>

                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[3].ref_score }}</div></td>
                            <td><div class="ref_score">{{ refEvaluation.saven_test.game_rules_data[3].ref_reverse_score }}</div></td>
                        </tr>

                        <tr class="evalution_item_name"
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >
                            <td>
                                <!--<TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id"
                                    @change="checkSelectedEval($event, evaluation.id)"
                                    :isChecked="isSelected(evaluation.id)" />-->
                            </td>
                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>

                            <td class="matching_col" :class="matchingClass(evaluation.saven_test.soft_skills_matching.toFixed(0))">
                                {{ evaluation.saven_test.soft_skills_matching.toFixed(0) }}%
                            </td>

                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[0].score, evaluation.saven_test.game_rules_data[0].ref_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[0].score }}
                                </div>
                            </td>
                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[0].reverse_score, evaluation.saven_test.game_rules_data[0].ref_reverse_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[0].reverse_score }}
                                </div>
                            </td>

                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[1].score, evaluation.saven_test.game_rules_data[1].ref_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[1].score }}
                                </div>
                            </td>
                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[1].reverse_score, evaluation.saven_test.game_rules_data[1].ref_reverse_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[1].reverse_score }}
                                </div>
                            </td>

                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[2].score, evaluation.saven_test.game_rules_data[2].ref_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[2].score }}
                                </div>
                            </td>
                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[2].reverse_score, evaluation.saven_test.game_rules_data[2].ref_reverse_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[2].reverse_score }}
                                </div>
                            </td>

                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[3].score, evaluation.saven_test.game_rules_data[3].ref_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[3].score }}
                                </div>
                            </td>
                            <td >
                                <div :class="proximityClass(evaluation.saven_test.game_rules_data[3].reverse_score, evaluation.saven_test.game_rules_data[3].ref_reverse_score)" class="circle_score">
                                    {{ evaluation.saven_test.game_rules_data[3].reverse_score }}
                                </div>
                            </td>



                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>
    import SkillsCompareModal from './skillsCompareModal'

    export default {
        name: 'PostitionEvalsGameRulesTab',
        props: ["evaluations", "currentPosition", "currentRef", "dataLoaded", "selectedPositionEvals"],
        components: {
            SkillsCompareModal
        },
        data(){
            return {
                current_sorting: null,
                SkillsCompareModalOpened: false
            }
        },
        computed: {
            refEvaluation(){
                return this.evaluations[0]
            },
            dimensionsPlan(){
                return this.currentPosition.dimensions_plan
            }
        },
        methods: {
            openSkillsCompareModal(position){
                this.SkillsCompareModalOpened = true
            },
            closeSkillsCompareModal(position){
                this.SkillsCompareModalOpened = false
            },
            isSelected(evaluationId){
                return this.selectedPositionEvals.includes(evaluationId)
            },
            checkSelectedEval(isChecked, evaluationId){
                this.$emit("SelectionCheckBoxClicked",{isChecked: isChecked, evaluationId: evaluationId} )
            },
            reorderEval(key){
                this.current_sorting = key
                this.$emit('reorderEval', key)
            },
            activeSortingClass(key){
                if (key  == this.current_sorting){
                    return 'active'
                }else{
                    return ''
                }
            },
            matchingSortingActive(){
                if ('soft_skills_matching' == this.current_sorting){
                    return 'active'
                }else{
                    return ''
                }
            },
            proximityClass(score, ref_score){
                
                const prox = Math.abs(ref_score - score.toFixed(0))
                return "proximity_" + prox
                
            },
            key_trad(key){
                const trad = 'dimensions.skills_short.' + key
                return this.$t(trad)
            },
            matchingClass(val){
                if(val < 25){return 'low'}
                if(val >= 25 && val < 50){return 'middleLow'}
                if(val >= 50 && val < 75){return 'middleHigh'}
                if(val >= 75){return 'high'}
            }
        }
    }
</script>

<style lang="scss" >

</style>
